import Helper from "./Helper";

class AccordionCol {
  constructor(config = {}) {
    const {
      accordionToggles,
    } = config;
    this.accordionToggles = Array.prototype.slice.call(document.querySelectorAll(accordionToggles));

    if (this.accordionToggles && this.accordionToggles.length !== 0) {
      this.toggleAccordion();
    }
  }


  closeOthers(currentItem) {
    const others = currentItem.closest('.ns-four-col-container__col')?.querySelectorAll('.ns-accordion-col-item');

    if (others || Array.isArray(others)) {
      others.forEach(item => {
        if (item != currentItem) {
          item.classList.remove("active");
          const content = item.querySelector('.ns-accordion-col-item__content');
          console.log(content)
          Helper.slideClose(content);
        }
      });
    }
  }

  toggleAccordion() {
    this.accordionToggles.forEach((accordionToggle) => {
      accordionToggle.addEventListener('click', () => {
        let closestItem = accordionToggle.closest('.ns-accordion-col-item');
        
        if (closestItem.classList.contains('active')) {
          closestItem.classList.remove('active');
          Helper.slideClose(closestItem.querySelector('.ns-accordion-col-item__content'));
        } else {
          closestItem.classList.add('active');
          Helper.slideOpen(closestItem.querySelector('.ns-accordion-col-item__content'));
          this.closeOthers(closestItem);
        }
      })
    });
  }
}

export default AccordionCol;





